import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { StaticDictionaryItem } from '../model/StaticDictionaryItem';
import { StaticDictionaryName } from '../model/StaticDictionaryName';
import { StaticDictionaryService } from '../services/static-dictionary.service';

@Pipe({ name: 'staticDictionaryCaption' })
export class StaticDictionaryCaptionPipe implements PipeTransform {

    constructor(private staticDictionaryService: StaticDictionaryService) {

    }

    transform(id: number, dictionaryName: StaticDictionaryName): Observable<string> {

        return this.staticDictionaryService.getStaticDictionary(dictionaryName).pipe(
            map((captions: StaticDictionaryItem[]) => {

                return captions.find(x => x.id === id)?.value;

            }));
    }
}